import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ct-shared-comment-button',
  template: `
    <button
      class="border-theme-gray-500 relative aspect-square cursor-pointer rounded-md border p-1.5 transition-colors"
      [ngClass]="{ 'bg-theme-blue': isChatPopupOpened() }"
      (click)="clicked.emit()"
      [pTooltip]="tooltip()">
      <img
        [ngClass]="isChatPopupOpened() ? 'invert-0' : 'invert-70'"
        class="pointer-events-none"
        src="@shared/comment.svg"
        class="w-5" />
      @if (doMessagesExist()) {
        <span
          class="bg-theme-red-500 pointer-events-none absolute top-0.5 right-0.5 h-2.5 w-2.5 rounded-full"></span>
      }
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Tooltip, NgClass],
})
export class CtCommentButtonComponent {
  readonly doMessagesExist = input.required<boolean>();
  readonly isChatPopupOpened = input.required<boolean>();

  protected readonly tooltip = computed(() =>
    this.doMessagesExist() ? 'Chat öffnen' : 'Keine Nachricht von SB',
  );

  clicked = output();
}
